import React from 'react';
import { createRoot } from 'react-dom/client';
import {
    HashRouter
} from 'react-router-dom';
import App from './App';
import { MenuProvider } from "./contexts/MenuContext";

const root = createRoot(document.getElementById('ultimate-security-settings'));

root.render(
    <HashRouter>
        <MenuProvider>
            <App />
        </MenuProvider>
    </HashRouter>
);